module.exports = __webpack_public_path__ + "static/media/Boat.285f9399.mp4";